import { p as proxyCustomElement, H, c as createEvent, A as AriaAttr, h } from './p-d7c3b756.js';
import { get, difference, isEmpty, find, map, includes, compact } from 'lodash-es';
import { B as BxfBadgeSizeEnum } from './p-61989e51.js';
import { d as defineCustomElement$4 } from './p-bcd74937.js';
import { d as defineCustomElement$3 } from './p-8c4c95dc.js';
import { d as defineCustomElement$2 } from './p-6c17fe8d.js';
import { d as defineCustomElement$1 } from './p-8fb4ef78.js';
import { F as FocusTrap, B as BxfPositionConstants } from './p-31d5cbf5.js';
import { j as getShadowRootElement, O as WindowEventMap, P as eventPath, l as createSelector, w as getKeyboardFocusCSS } from './p-0856cfca.js';
import { B as BxfOverlayMenuController } from './p-3e4b76ad.js';
import { B as BxfInlineMenuConstants } from './p-223f0e48.js';
import { u as uuidv4 } from './p-2b83a1d1.js';
import { e as BxfOverlayTriggerEnum, b as BxfDynamicPositionEnum } from './p-7397c455.js';
import { B as BxfDefaultState } from './p-7451d809.js';
import { i as isUsingI18n, B as BxfI18n, t as translateKeys } from './p-01256821.js';
import { K as KeyboardEventKey } from './p-b3de3bce.js';
import { F as FocusIndexManager } from './p-8b298ca7.js';
import { R as Role } from './p-2c2985b9.js';
import { j as BxfIconTypeEnum } from './p-59460191.js';
import { B as BxfButtonSizeEnum } from './p-08621ebf.js';
import { B as BxfButtonTypeEnum } from './p-4493a6cc.js';

const bxfInlineMenuCss = "button.sc-bxf-inline-menu:hover,a.sc-bxf-inline-menu:hover,input[type=radio].sc-bxf-inline-menu:hover,input[type=checkbox].sc-bxf-inline-menu:hover,input[type=radio].sc-bxf-inline-menu:checked:hover,input[type=checkbox].sc-bxf-inline-menu:checked:hover,svg.sc-bxf-inline-menu:hover{cursor:pointer}svg[disabled].sc-bxf-inline-menu:hover,button[disabled].sc-bxf-inline-menu:hover,label[disabled].sc-bxf-inline-menu:hover,input[type=checkbox].sc-bxf-inline-menu:disabled:hover,input[type=radio].sc-bxf-inline-menu:disabled:hover,input[type=checkbox].sc-bxf-inline-menu:checked:disabled:hover,input[type=radio].sc-bxf-inline-menu:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-inline-menu{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.oneds-blk-heading-display-1.sc-bxf-inline-menu{font-size:clamp(2.3675rem, 1.3308rem + 4.6074vw, 5.4775rem);line-height:1.22;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-display-1.sc-bxf-inline-menu{line-height:1.21}}@media (min-width: 48rem){.oneds-blk-heading-display-1.sc-bxf-inline-menu{line-height:1.2}}@media (min-width: 64rem){.oneds-blk-heading-display-1.sc-bxf-inline-menu{line-height:1.18}}@media (min-width: 90rem){.oneds-blk-heading-display-1.sc-bxf-inline-menu{line-height:1.16}}.oneds-blk-heading-xxl.sc-bxf-inline-menu{font-size:clamp(2.0931rem, 1.3588rem + 3.2639vw, 4.2963rem);line-height:1.22;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-xxl.sc-bxf-inline-menu{line-height:1.22}}@media (min-width: 48rem){.oneds-blk-heading-xxl.sc-bxf-inline-menu{line-height:1.21}}@media (min-width: 64rem){.oneds-blk-heading-xxl.sc-bxf-inline-menu{line-height:1.2}}@media (min-width: 90rem){.oneds-blk-heading-xxl.sc-bxf-inline-menu{line-height:1.18}}.oneds-blk-heading-xl.sc-bxf-inline-menu{font-size:clamp(1.8506rem, 1.3444rem + 2.25vw, 3.3694rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-xl.sc-bxf-inline-menu{line-height:1.22}}@media (min-width: 48rem){.oneds-blk-heading-xl.sc-bxf-inline-menu{line-height:1.22}}@media (min-width: 64rem){.oneds-blk-heading-xl.sc-bxf-inline-menu{line-height:1.21}}@media (min-width: 90rem){.oneds-blk-heading-xl.sc-bxf-inline-menu{line-height:1.2}}.oneds-blk-heading-l.sc-bxf-inline-menu{font-size:clamp(1.6363rem, 1.3008rem + 1.4907vw, 2.6425rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-l.sc-bxf-inline-menu{line-height:1.23}}@media (min-width: 48rem){.oneds-blk-heading-l.sc-bxf-inline-menu{line-height:1.23}}@media (min-width: 64rem){.oneds-blk-heading-l.sc-bxf-inline-menu{line-height:1.22}}@media (min-width: 90rem){.oneds-blk-heading-l.sc-bxf-inline-menu{line-height:1.21}}.oneds-blk-heading-m.sc-bxf-inline-menu{font-size:clamp(1.4469rem, 1.2383rem + 0.9269vw, 2.0725rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-m.sc-bxf-inline-menu{line-height:1.23}}@media (min-width: 48rem){.oneds-blk-heading-m.sc-bxf-inline-menu{line-height:1.23}}@media (min-width: 64rem){.oneds-blk-heading-m.sc-bxf-inline-menu{line-height:1.23}}@media (min-width: 90rem){.oneds-blk-heading-m.sc-bxf-inline-menu{line-height:1.22}}.oneds-blk-heading-s.sc-bxf-inline-menu{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-s.sc-bxf-inline-menu{line-height:1.24}}@media (min-width: 48rem){.oneds-blk-heading-s.sc-bxf-inline-menu{line-height:1.24}}@media (min-width: 64rem){.oneds-blk-heading-s.sc-bxf-inline-menu{line-height:1.24}}@media (min-width: 90rem){.oneds-blk-heading-s.sc-bxf-inline-menu{line-height:1.23}}.oneds-blk-heading-xs.sc-bxf-inline-menu{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-heading-xxs.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-eyebrow-l.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.27;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-eyebrow-m.sc-bxf-inline-menu{font-size:14px;line-height:1.3;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-eyebrow-s.sc-bxf-inline-menu{font-size:12px;line-height:1.34;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xl.sc-bxf-inline-menu{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xl-bold.sc-bxf-inline-menu{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xl-italic.sc-bxf-inline-menu{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-xl-link.sc-bxf-inline-menu{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-l.sc-bxf-inline-menu{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-l-bold.sc-bxf-inline-menu{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-l-italic.sc-bxf-inline-menu{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-l-link.sc-bxf-inline-menu{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-m.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-bold.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-italic.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-m-link.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-m-compact.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-compact-bold.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-compact-italic.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-m-compact-link.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-s.sc-bxf-inline-menu{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-bold.sc-bxf-inline-menu,.bxf-inline-menu__item.sc-bxf-inline-menu,.bxf-inline-menu__item--compact.sc-bxf-inline-menu{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-italic.sc-bxf-inline-menu{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-s-link.sc-bxf-inline-menu{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-s-compact.sc-bxf-inline-menu{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-compact-bold.sc-bxf-inline-menu{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-compact-italic.sc-bxf-inline-menu{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-s-compact-link.sc-bxf-inline-menu{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-xs.sc-bxf-inline-menu{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-bold.sc-bxf-inline-menu{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-italic.sc-bxf-inline-menu{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-xs-link.sc-bxf-inline-menu{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-xs-compact.sc-bxf-inline-menu{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-compact-bold.sc-bxf-inline-menu{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-compact-italic.sc-bxf-inline-menu{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-xs-compact-link.sc-bxf-inline-menu{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu a.sc-bxf-inline-menu{font-size:clamp(2.0931rem, 1.3588rem + 3.2639vw, 4.2963rem);line-height:1.22;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-m) 0 var(--oneds-space-fluid-m) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.22}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.21}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.2}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.18}}.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu strong.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu em.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h1.sc-bxf-inline-menu a.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu a.sc-bxf-inline-menu{font-size:clamp(1.8506rem, 1.3444rem + 2.25vw, 3.3694rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-s) 0 var(--oneds-space-fluid-m) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.22}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.22}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.21}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.2}}.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu strong.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu em.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h2.sc-bxf-inline-menu a.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu a.sc-bxf-inline-menu{font-size:clamp(1.6363rem, 1.3008rem + 1.4907vw, 2.6425rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-xs) 0 var(--oneds-space-fluid-s) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.23}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.23}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.22}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.21}}.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu strong.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu em.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h3.sc-bxf-inline-menu a.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu a.sc-bxf-inline-menu{font-size:clamp(1.4469rem, 1.2383rem + 0.9269vw, 2.0725rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-xxs) 0 var(--oneds-space-fluid-xs) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.23}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.23}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.23}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.22}}.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu strong.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu em.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h4.sc-bxf-inline-menu a.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu a.sc-bxf-inline-menu{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-xxxs) 0 var(--oneds-space-fluid-xxs) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.24}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.24}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.24}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu a.sc-bxf-inline-menu{line-height:1.23}}.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu strong.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu em.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h5.sc-bxf-inline-menu a.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-inline-menu h6.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h6.sc-bxf-inline-menu strong.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h6.sc-bxf-inline-menu em.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu h6.sc-bxf-inline-menu a.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding-bottom:var(--oneds-space-xxs)}.oneds-richTextEditorOutput.sc-bxf-inline-menu h6.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h6.sc-bxf-inline-menu strong.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h6.sc-bxf-inline-menu em.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-inline-menu h6.sc-bxf-inline-menu a.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-inline-menu p.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-inline-menu ul.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu ol.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:0 0 var(--oneds-space-m) var(--oneds-space-m);list-style-type:revert}.oneds-richTextEditorOutput.sc-bxf-inline-menu ul.sc-bxf-inline-menu li.sc-bxf-inline-menu:not(:last-child),.oneds-richTextEditorOutput.sc-bxf-inline-menu ol.sc-bxf-inline-menu li.sc-bxf-inline-menu:not(:last-child){padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-inline-menu strong.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-inline-menu em.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic;padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-inline-menu a.sc-bxf-inline-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline;color:var(--oneds-text-default);text-decoration:underline;text-decoration-thickness:2px;text-underline-offset:3px;transition:text-decoration 300ms ease-out}.oneds-richTextEditorOutput.sc-bxf-inline-menu .mce-content-body.sc-bxf-inline-menu [data-mce-selected=inline-boundary].sc-bxf-inline-menu{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-inline-menu a.sc-bxf-inline-menu:hover,.oneds-richTextEditorOutput.sc-bxf-inline-menu a.sc-bxf-inline-menu:active{text-decoration:underline;text-decoration-thickness:4px;transition:text-decoration 100ms ease-out}.oneds-richTextEditorOutput.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible{background:var(--oneds-bg-black);color:var(--oneds-text-inverse);text-decoration:none;border:none;outline:none;border-radius:0}.oneds-richTextEditorOutput.oneds-bg-black.sc-bxf-inline-menu a.sc-bxf-inline-menu{color:var(--oneds-text-inverse)}.oneds-richTextEditorOutput.oneds-bg-black.sc-bxf-inline-menu a.sc-bxf-inline-menu:focus-visible{background:var(--oneds-bg-white);color:var(--oneds-text-default);text-decoration:none;border:none;outline:none;border-radius:0}.oneds-richTextEditorOutput.sc-bxf-inline-menu sub.sc-bxf-inline-menu,.oneds-richTextEditorOutput.sc-bxf-inline-menu sup.sc-bxf-inline-menu{line-height:0}.bxf-inline-menu__container.sc-bxf-inline-menu{height:100%;width:fit-content}.bxf-inline-menu__close-button.sc-bxf-inline-menu{position:absolute;right:16px}.bxf-inline-menu__show.sc-bxf-inline-menu{display:flex;position:absolute;flex-direction:column;right:0;z-index:1100;top:105%}.bxf-inline-menu__hide.sc-bxf-inline-menu{display:none}.bxf-inline-menu__show.sc-bxf-inline-menu,.bxf-inline-menu__flyout.sc-bxf-inline-menu{display:inline-block;width:fit-content;min-width:8.75rem;background-color:#ffffff;box-shadow:8px 8px 24px 0px rgba(0, 0, 0, 0.2);border:none;padding:16px;margin:0;border-radius:1rem;box-shadow:0 0.375rem 12px 0 rgba(0, 0, 0, 0.1)}.bxf-inline-menu__item-wrapper.sc-bxf-inline-menu{list-style:none;padding-right:12px}.bxf-inline-menu__item.sc-bxf-inline-menu{display:flex;color:#000000;font-size:0.8125rem;line-height:2rem;height:2rem;width:100%;overflow:hidden}.bxf-inline-menu__item.sc-bxf-inline-menu:hover{color:#ff4713}.bxf-inline-menu__item.sc-bxf-inline-menu:hover{cursor:pointer}.bxf-inline-menu__item.sc-bxf-inline-menu:focus{outline:0.0625rem dotted #265cb2;outline:auto #265cb2}.bxf-inline-menu__item.bxf__focus--keyboard-only.sc-bxf-inline-menu:focus:not(:focus-visible){outline:0}.bxf-inline-menu__item--compact.sc-bxf-inline-menu{display:flex;color:#000000;font-size:0.8125rem;line-height:1.25rem;height:1.25rem;width:100%}.bxf-inline-menu__item--compact.sc-bxf-inline-menu:hover{color:#ff4713}.bxf-inline-menu__item--compact.sc-bxf-inline-menu:hover{cursor:pointer}.bxf-inline-menu__item--compact.sc-bxf-inline-menu:focus{outline:0.0625rem dotted #265cb2;outline:auto #265cb2}.bxf-inline-menu__item--compact.bxf__focus--keyboard-only.sc-bxf-inline-menu:focus:not(:focus-visible){outline:0}.bxf-inline-menu__item.disabled.sc-bxf-inline-menu{color:#aeaba7}.bxf-inline-menu__item.disabled.sc-bxf-inline-menu:hover:focus{outline:none}.bxf-inline-menu__item.disabled.sc-bxf-inline-menu:hover{cursor:default}.bxf-inline-menu__item.alert.sc-bxf-inline-menu{color:#c00b28}.bxf-inline-menu__item.selected.sc-bxf-inline-menu{background-color:#eae7e1}.bxf-inline-menu__group.sc-bxf-inline-menu{display:flex;flex-direction:column;gap:0.5rem}.bxf-inline-menu__group.bxf__mouse-focus.sc-bxf-inline-menu .bxf-inline-menu__item.sc-bxf-inline-menu:focus{outline:none}.bxf-inline-menu__group-separator.sc-bxf-inline-menu{height:0;border-bottom:0.0625rem solid #d9d6ce;margin-top:4px;margin-bottom:4px}.bxf-inline-menu__left-icon.sc-bxf-inline-menu{display:flex;justify-content:center;width:16px;padding:0 8px;pointer-events:none;align-items:center;line-height:0}.bxf-inline-menu__no-left-icon.sc-bxf-inline-menu{padding-left:12px;pointer-events:none}.bxf-inline-menu__right.sc-bxf-inline-menu,.bxf-inline-menu__right-icon.sc-bxf-inline-menu{display:flex;justify-content:center;margin-left:auto;min-width:16px;padding:0 12px 0 8px;line-height:0;align-items:center}.bxf-inline-menu__right-icon.sc-bxf-inline-menu{pointer-events:none}.bxf-inline-menu__no-right-icon.sc-bxf-inline-menu{padding-right:12px;pointer-events:none}.bxf-inline-menu__override-background.sc-bxf-inline-menu{background-color:#ffffff !important}.bxf-inline-menu__secondary-label.sc-bxf-inline-menu{color:#6b6a67;font-size:12px;padding:0 12px 0 8px;margin-left:auto;pointer-events:none}";
const BxfInlineMenuStyle0 = bxfInlineMenuCss;

const { LEFT_TOP, RIGHT_TOP, LEFT_BOTTOM, RIGHT_BOTTOM, BOTTOM_LEFT, BOTTOM_CENTER, BOTTOM_RIGHT, TOP_LEFT, TOP_CENTER, TOP_RIGHT, } = BxfDynamicPositionEnum;
const { GROUP_SEPARATOR, DISABLED, ALERT, CLOSE_BUTTON, MENU_ITEM_WRAPPER, MENU_ITEM, MENU_GROUP, MENU_LEFT_ICON, MENU_LEFT_ICON_NO, ITEM_RIGHT, MENU_RIGHT_ICON, MENU_RIGHT_ICON_NO, SECONDARY_LABEL, FLYOUT, FLYOUT_DATA, CHECK, ALERT_ICON, ARROW_RIGHT, SHOW, HIDE, TARGET, SELECTED, BXF_THEME_LIGHT, IS_NAV_MENU, MENU_NAV_BACKGROUND, PRIMARY, BUTTON, CONTAINER, MENU_ITEM_COMPACT, } = BxfInlineMenuConstants.STRING;
const { MENU_CONTAINER } = BxfPositionConstants.STRING;
const BUTTON_TYPES = [
    BxfButtonTypeEnum.TERTIARY,
    BxfButtonTypeEnum.TERTIARY_SUBTLE,
    BxfButtonTypeEnum.AFFIRMATIVE_TERTIARY,
    BxfButtonTypeEnum.DESTRUCTIVE_TERTIARY,
];
const BxfInlineMenu = /*@__PURE__*/ proxyCustomElement(class BxfInlineMenu extends H {
    /**
     * Event is emitted when an option is clicked
     */
    inlineMenuItemClicked;
    /**
     * This event is emitted when popover overlay is opened
     */
    menuOpened;
    /**
     * This event is emitted when popover overlay is closed
     */
    menuClosed;
    /**
     * Public method that would open the calendar overlay
     * @returns {Promise<boolean>}
     */
    async open() {
        this.isOpen = true;
    }
    /**
     * Public method that would close the calendar overlay
     * @returns {Promise<boolean>}
     */
    async close() {
        this.isOpen = false;
    }
    _overlay;
    _parentRef;
    _targetRef;
    _sourceRef;
    _flyoutOverlaysMap = {};
    _flyoutTargetRefMap = {};
    _flyoutSourceRefMap = {};
    _sourceElementOptions;
    _keepOverlayOpen = false;
    _hasEmptyIcon = false;
    i18n;
    /**
     * UUID to ensure unique flyout IDs in dom
     */
    _uid = uuidv4();
    get host() { return this; }
    isOpenHandler(newProp) {
        newProp ? this.openOverlay() : this.closeOverlay();
    }
    handleTabSwitch() {
        if (this.isOpen) {
            this.close();
        }
    }
    constructor() {
        super();
        this.__registerHost();
        this.inlineMenuItemClicked = createEvent(this, "inlineMenuItemClicked", 7);
        this.menuOpened = createEvent(this, "menuOpened", 7);
        this.menuClosed = createEvent(this, "menuClosed", 7);
        this.data = [];
        this.trigger = BxfOverlayTriggerEnum.PRESSED;
        this.hoverClass = undefined;
        this.metadata = undefined;
        this.eventData = {};
        this.overridePlacement = undefined;
        this.sourceElementCustomClass = [];
        this.targetElementCustomClass = [];
        this.scrollToFit = true;
        this.isTracking = true;
        this.trackingData = undefined;
        this.isCompact = BxfDefaultState.isCompact;
        this.assistiveLabel = undefined;
        this.parentOverlayContainerSelector = 'body';
        this.dataTestSuffix = undefined;
        this.isOpen = false;
        this.keepMouseFocus = false;
        this.namespaceI18n = undefined;
        this.i18nKeys = undefined;
        this.useFocusVisible = true;
        this.isFlyoutOpenMap = {};
        this.itemHovered = undefined;
        this.flyoutMouseOverHandler = this.flyoutMouseOverHandler.bind(this);
        this.flyoutMouseOutHandler = this.flyoutMouseOutHandler.bind(this);
        this.isFlyoutOverlayOpen = this.isFlyoutOverlayOpen.bind(this);
        this.updateState = this.updateState.bind(this);
        this.isOnTarget = this.isOnTarget.bind(this);
        this.isOutsideOverlay = this.isOutsideOverlay.bind(this);
    }
    componentWillLoad() {
        /* istanbul ignore else */
        if (isUsingI18n() && this.namespaceI18n) {
            this.initI18n();
        }
        this.initRovingTabIndex(this.data);
        this.initSetHasNoIcons(this.data);
        this._sourceElementOptions = get(this.metadata, IS_NAV_MENU)
            ? {
                addClassNames: [
                    BXF_THEME_LIGHT,
                    MENU_NAV_BACKGROUND,
                    ...this.sourceElementCustomClass,
                ],
            }
            : {
                addClassNames: [...this.sourceElementCustomClass],
            };
    }
    initI18n() {
        this.i18n = new BxfI18n(this.namespaceI18n);
        window['i18n'].on('languageChanged', () => {
            this.i18n.languageChangedHandler(this.translateText());
        });
        window['i18n'].on('loaded', () => {
            this.translateText();
        });
    }
    translateText() {
        translateKeys(this, this.i18nKeys, this.i18n);
        this.data?.forEach((inlineMenu) => {
            this.translateContent(inlineMenu);
        });
    }
    translateContent(data) {
        data?.forEach((element) => {
            element.flyoutData?.forEach((item) => {
                this.translateContent(item);
            });
            translateKeys(element, element.i18nKeys, this.i18n);
        });
    }
    componentDidRender() {
        this.getElementForSplitButton();
        this.initOverlayController();
        this.updateState(this.isOpen);
    }
    disconnectedCallback() {
        this.closeOverlay();
        this.i18n?.destroyTranslations();
    }
    /**
     * For nav menu item, open overlay on down arrow
     * @param {KeyboardEvent} event
     */
    downArrowHandler(event) {
        if (event.key === KeyboardEventKey.ArrowDown) {
            event.preventDefault();
            this.open();
        }
    }
    /**
     * Given a menu ref and a parent index, find all immediate (non-flyout) menu
     * children for that ref.
     */
    getImmediateMenuChildren(ref, index) {
        if (index) {
            return Array.from(ref.querySelectorAll(`[data-bxf-parent=${index}] .${MENU_ITEM}`));
        }
        const menuItemArray = Array.from(ref.querySelectorAll(`.${MENU_GROUP} .${MENU_ITEM}`));
        const menuItemWithParentArray = Array.from(ref.querySelectorAll(`.${MENU_GROUP}[data-bxf-parent] .${MENU_ITEM}`));
        return difference(menuItemArray, menuItemWithParentArray);
    }
    /**
     * Given an array of focusable children, return the index in the array
     * where the active element is
     */
    getIndexOfActiveElement(focusableChildren) {
        const activeElem = FocusTrap.getFocusedElem('document');
        return focusableChildren.findIndex((e) => activeElem === e);
    }
    /**
     * Move focus between menu items on Up/Down arrow key.
     * @param {KeyboardEvent} event
     * @param {HTMLElement} ref
     * @param {string} parentIndex
     */
    navKeyEventHandler(event, ref, parentIndex) {
        const focusableChildren = this.getImmediateMenuChildren(ref, parentIndex);
        const activeIndex = this.getIndexOfActiveElement(focusableChildren);
        /* istanbul ignore else */
        if (activeIndex !== -1) {
            event.preventDefault();
            const focusIndex = FocusIndexManager.getFocusIndexForNavEvent(focusableChildren, activeIndex, event);
            focusableChildren[activeIndex].tabIndex = -1;
            focusableChildren[focusIndex].tabIndex = 0;
            focusableChildren[focusIndex].focus();
        }
    }
    /**
     * Handle keydown events for a given menu
     */
    menuKeyDownHandler(event, ref, parentIndex) {
        const navKeys = FocusIndexManager.VERTICAL_NAV_KEYS;
        const closeKeys = [KeyboardEventKey.ArrowLeft, KeyboardEventKey.Escape];
        if (navKeys.includes(event.key)) {
            event.stopPropagation();
            this.navKeyEventHandler(event, ref, parentIndex);
        }
        else if (closeKeys.includes(event.key)) {
            this.menuItemLeftKeyHandler(parentIndex, event);
        }
    }
    /**
     * Given an array of flyout menu items, make only the first item in the menu,
     * 	and the first item in any flyout menu items, keyboard focusable
     */
    initRovingTabIndex(data) {
        /* istanbul ignore else */
        if (!isEmpty(data) && !isEmpty(data[0])) {
            data.forEach((arr) => {
                arr.forEach((item) => {
                    item.isFocusable = false;
                    if (item.flyoutData) {
                        this.initRovingTabIndex(item.flyoutData);
                    }
                });
            });
            data[0][0].isFocusable = true;
        }
    }
    /**
     * Given an array of flyout menu items, check if any item has an icon
     * If they don't, remove empty icon padding.
     */
    initSetHasNoIcons(data) {
        /* istanbul ignore else */
        if (!isEmpty(data)) {
            /* istanbul ignore else */
            if (!this._hasEmptyIcon)
                this._hasEmptyIcon = true;
            let hasNoIcons = true;
            data.forEach((arr) => {
                arr.forEach((item) => {
                    if (item.leftIcon || item.isSelected)
                        hasNoIcons = false;
                    item.hasEmptyIcon = true;
                    if (item.flyoutData) {
                        this.initSetHasNoIcons(item.flyoutData);
                    }
                });
            });
            if (hasNoIcons) {
                this._hasEmptyIcon = false;
                data.forEach((arr) => {
                    arr.forEach((item) => {
                        item.hasEmptyIcon = false;
                    });
                });
            }
        }
    }
    closeOverlay() {
        this.isOpen = false;
        if (this._overlay) {
            this._overlay.close();
            this._overlay = null;
        }
        this.closeOpenFlyouts();
        this.menuClosed.emit({ eventData: this.eventData });
    }
    openOverlay() {
        if (this.isOpen && this._overlay) {
            this._overlay.open();
            this.menuOpened.emit({ eventData: this.eventData });
        }
    }
    getElementForSplitButton() {
        const _targetEl = get(this._targetRef, 'children[0]');
        if (_targetEl?.splitIcon) {
            const data = getShadowRootElement(_targetEl).querySelectorAll(BUTTON);
            if (get(data, 'length') > 1) {
                this._targetRef = data[1];
            }
        }
    }
    /**
     * Retrieve target options for overlay, including:
     *  - custom class
     *  - down key handler for nav menu item
     * @returns {BxfOverlayControllerTargetElementOptionsInterface}
     */
    getTargetElementOptions() {
        const targetOptions = {
            addClassNames: [...this.targetElementCustomClass],
        };
        // attach down key event listener for primary navigation if trigger=hover
        if (this.trigger === BxfOverlayTriggerEnum.HOVER &&
            this.metadata &&
            this.metadata.isNavMenu) {
            const targetEventsMap = {};
            targetEventsMap[WindowEventMap.keydown] = this.downArrowHandler;
            targetOptions.targetEventsMap = targetEventsMap;
        }
        else if (this.trigger === BxfOverlayTriggerEnum.PRESSED) {
            targetOptions.targetEventType = [WindowEventMap.mouseup];
        }
        return targetOptions;
    }
    initOverlayController() {
        /* istanbul ignore else */
        if (!this._overlay &&
            this._parentRef
        // this._parentRef &&
        // this._targetRef &&
        // this._sourceRef
        ) {
            const options = {
                trigger: this.trigger,
                overlaysToClose: [MENU_CONTAINER],
                modifiers: {
                    padding: 4,
                    flipOrder: [
                        BOTTOM_LEFT,
                        BOTTOM_CENTER,
                        BOTTOM_RIGHT,
                        TOP_LEFT,
                        TOP_CENTER,
                        TOP_RIGHT,
                    ],
                    defaultPlacement: this.overridePlacement || BOTTOM_LEFT,
                    scrollToFit: this.scrollToFit,
                    elementHeightStatus: {
                        originalElementHeight: BxfPositionConstants.STRING.INITIAL_ELEMENT_HEIGHT,
                    },
                },
                keepMouseFocus: this.keepMouseFocus,
                useFocusVisible: this.useFocusVisible,
                sourceElementOptions: this._sourceElementOptions,
                targetElementOptions: this.getTargetElementOptions(),
                isChildOverlayOpenCallback: this.isFlyoutOverlayOpen,
                shouldCloseOnMouseUp: true,
            };
            this._overlay = new BxfOverlayMenuController(this.host, this._parentRef, this._parentRef.firstElementChild, this._sourceRef, this.updateState, options, this.getOutsideOverlayCallback());
        }
    }
    /**
     * Get outside overlay callback depending on trigger.
     */
    getOutsideOverlayCallback() {
        return this.trigger === BxfOverlayTriggerEnum.HOVER
            ? this.isOnTarget
            : this.isOutsideOverlay;
    }
    /**
     * Do not close overlay when clicked on target element if trigger is hover
     */
    isOnTarget(event) {
        return (this.isOutsideOverlay(event) &&
            !(event && find(eventPath(event), (val) => val == this._targetRef)));
    }
    /**
     * Check if mouse event occurred outside menu and flyout
     */
    isOutsideOverlay(event) {
        return (!map(eventPath(event), BxfPositionConstants.STRING.CLASSNAME).find((el) => includes(el, SHOW)) &&
            !map(eventPath(event), BxfPositionConstants.STRING.CLASSNAME).find((el) => includes(el, FLYOUT)));
    }
    updateState(value) {
        if (value) {
            this.isOpen = true;
        }
        else if (!this.isFlyoutOverlayOpen()) {
            // If flyout menus are open then we should not close the main menu overlay
            this.isOpen = false;
        }
    }
    isFlyoutOverlayOpen() {
        if (this.trigger === BxfOverlayTriggerEnum.HOVER) {
            return (!isEmpty(compact(map(this.isFlyoutOpenMap, (v) => v))) ||
                this._keepOverlayOpen);
        }
        return (!isEmpty(compact(map(this.isFlyoutOpenMap, (v) => v))) &&
            this._keepOverlayOpen);
    }
    flyoutTargetRefHandler(el, key) {
        /* istanbul ignore else */
        if (el) {
            this._flyoutTargetRefMap[key] = el;
            this.initFlyoutOverlayController(key);
        }
    }
    flyoutSourceRefHandler(el, key) {
        /* istanbul ignore else */
        if (el) {
            this._flyoutSourceRefMap[key] = el;
            this.initFlyoutOverlayController(key);
        }
    }
    getOpenFlyoutsKeys() {
        return compact(map(this.isFlyoutOpenMap, (isOpen, flyoutKey) => {
            if (isOpen) {
                return flyoutKey;
            }
            return null;
        }));
    }
    initFlyoutOverlayController(key) {
        if (!this._flyoutOverlaysMap[key] &&
            this._parentRef &&
            this._flyoutTargetRefMap[key] &&
            this._flyoutSourceRefMap[key]) {
            let currentFlyoutMenuDepth;
            /* istanbul ignore else */
            if (this._flyoutSourceRefMap[key]) {
                // Splits the key on _number_number. Each occurrence of this indicates another flyout menu
                currentFlyoutMenuDepth = key.match(/((_\d{1,2}){2})/gm).length;
            }
            const options = {
                trigger: BxfOverlayTriggerEnum.HOVER,
                modifiers: {
                    padding: 0,
                    flipOrder: [LEFT_TOP, RIGHT_TOP, LEFT_BOTTOM, RIGHT_BOTTOM],
                    defaultPlacement: LEFT_TOP,
                    scrollToFit: this.scrollToFit,
                    currentFlyoutMenuDepth,
                },
                keepMouseFocus: this.keepMouseFocus,
                sourceElementOptions: this._sourceElementOptions,
                targetElementOptions: {
                    addClassNames: [...this.targetElementCustomClass],
                },
                closeOnEscape: false,
                isFlyoutMenu: true,
                shouldCloseOnMouseUp: true,
            };
            this._flyoutOverlaysMap[key] = new BxfOverlayMenuController(this.host, this._parentRef, this._flyoutTargetRefMap[key], this._flyoutSourceRefMap[key], this.updateFlyoutState.bind(this, key), options, this.getOutsideOverlayCallback());
        }
    }
    /**
     * Remove item with aria-owns=<id of flyout> from DOM
     */
    removeFlyoutOwnsSibling(key) {
        const parentRef = this._flyoutTargetRefMap[key].parentElement;
        // remove flyout owner from DOM, not needed anymore
        const flyoutOwner = parentRef.querySelector(`[data-bxf-owns="${key}"]`);
        if (flyoutOwner) {
            parentRef.removeChild(flyoutOwner);
        }
    }
    /**
     * After closing a flyout menu, update the following ARIA attributes:
     *  - set aria-expanded to false
     *  - remove sibling with aria-owns=<id of flyout>, as it is no longer needed
     */
    setAriaAttrsForClosedTarget(key) {
        /* istanbul ignore else  */
        if (this._flyoutTargetRefMap[key]) {
            // NOTE: string "true" or "false" needed for aria-expanded, not boolean
            this._flyoutTargetRefMap[key].setAttribute(AriaAttr.EXPANDED, 'false');
            this.removeFlyoutOwnsSibling(key);
        }
    }
    /**
     * Add empty container with aria-owns=(id of flyout) as a sibling of target.
     * 	This will keep flyout menu an immediate sibling of parent menuitem
     * 	even when overlay controller changes DOM structure.
     *
     * Explicitly set role=presentation on container to keep container out of
     * 	accessibility tree, but keep child (via aria-owns) in tree, so tree will
     * 	look like:
     * - menu
     * 	- menuitem "Flyout parent"
     * 	- menu "Flyout parent"
     * 	  - menuitem "Flyout child"
     *
     * NOTE: we cannot set aria-owns on the parent listitem, as that will
     * 	override its role from none to listitem
     *
     * @see [WAI-ARIA authoring practices - Menu](https://www.w3.org/TR/wai-aria-practices-1.1/#wai-aria-roles-states-and-properties-13)
     */
    addFlyoutOwnsSibling(key) {
        const flyoutOwner = document.createElement('div');
        flyoutOwner.setAttribute(AriaAttr.ROLE, Role.PRESENTATION);
        flyoutOwner.setAttribute(AriaAttr.OWNS, this.getFlyoutId(key));
        // using data-bxf-owns to provide shorthand for unique ID
        flyoutOwner.dataset.bxfOwns = key;
        this._flyoutTargetRefMap[key].parentElement.appendChild(flyoutOwner);
    }
    /**
     * After opening a flyout menu, update the following ARIA attributes:
     *  - set aria-expanded to true
     *  - add sibling with aria-owns=<id of flyout> (see addFlyoutOwnsSibling for
     * 		why this is needed)
     */
    setAriaAttrsForOpenTarget(key) {
        /* istanbul ignore else  */
        if (this._flyoutTargetRefMap[key]) {
            // NOTE: string "true" or "false" needed for aria-expanded, not boolean
            this._flyoutTargetRefMap[key].setAttribute(AriaAttr.EXPANDED, 'true');
            this.addFlyoutOwnsSibling(key);
        }
    }
    /**
     * Toggle a flyout menu to a given value
     */
    updateFlyoutState(key, value) {
        if (value) {
            this.isFlyoutOpenMap[key] = true;
            /* istanbul ignore else */
            if (this._flyoutOverlaysMap[key]) {
                this._flyoutOverlaysMap[key].openOverlayWithPosition();
            }
            this.setAriaAttrsForOpenTarget(key);
        }
        else {
            this._flyoutOverlaysMap[key] = null;
            this.initFlyoutOverlayController(key);
            this.isFlyoutOpenMap[key] = false;
            this.setAriaAttrsForClosedTarget(key);
            /**
             * If all the flyout menus are closed and mouse is hovered outside inline
             * 	menu overlay then we should close the overlay
             */
            if (this.trigger === BxfOverlayTriggerEnum.HOVER &&
                !this.isFlyoutOverlayOpen()) {
                this.close();
            }
        }
    }
    /**
     * When enter key pressed, close all flyouts
     */
    closeOpenFlyouts() {
        /* istanbul ignore else */
        if (this.isFlyoutOpenMap) {
            // find all open flyout menus
            const openIndices = this.getOpenFlyoutsKeys();
            openIndices.forEach((index) => {
                /* istanbul ignore else */
                if (this._flyoutOverlaysMap[index]) {
                    this._flyoutOverlaysMap[index].close();
                }
                this.updateFlyoutState(index, false);
            });
        }
    }
    /**
     * Event handler for selection of inline menu item
     */
    menuItemClickHandler(item, key, event) {
        if (item.isDisabled) {
            event.stopPropagation();
            this._keepOverlayOpen = true;
            return;
        }
        this.inlineMenuItemClicked.emit({
            element: item,
            host: this.host,
            srcEvent: event,
            eventData: this.eventData,
        });
        this._keepOverlayOpen = false;
        if (this._flyoutOverlaysMap[key]) {
            this._flyoutOverlaysMap[key].close(!this.keepMouseFocus);
        }
        this.updateFlyoutState(key, false);
        this.closeOpenFlyouts();
        this.close();
    }
    /**
     * Keyboard event handler for selection of inline menu item.
     * 	- Do not allow disabled items to be selected
     *  - If item not disabled, emit click event.
     *  - When item selected that has flyout menu, toggle flyout menu. Otherwise, close the menu.
     * @param {BxfInlineMenuInterface} item
     * @param {string} key
     * @param {KeyboardEvent} event
     * @returns {void}
     */
    menuItemEnterHandler(item, key, event) {
        if (item.isDisabled) {
            event.stopPropagation();
            this._keepOverlayOpen = true;
            return;
        }
        this.inlineMenuItemClicked.emit({
            element: item,
            host: this.host,
            srcEvent: event,
            eventData: this.eventData,
        });
        if (item.flyoutData) {
            event.stopPropagation();
            this._keepOverlayOpen = true;
            this.updateFlyoutState(key, true);
            // focus focusable item inside menu
            /* istanbul ignore else */
            if (this._flyoutSourceRefMap[key]) {
                setTimeout(() => {
                    FocusTrap.focusFirstElem(this._flyoutSourceRefMap[key], false);
                });
            }
        }
        else {
            this._keepOverlayOpen = false;
            if (this._flyoutOverlaysMap[key]) {
                this._flyoutOverlaysMap[key].close();
            }
            this.updateFlyoutState(key, false);
            this.closeOpenFlyouts();
            this.close();
        }
    }
    /**
     * On right arrow key press, if a menu item has a flyout menu,
     *  expand the flyout menu
     */
    menuItemRightKeyHandler(item, key, event) {
        if (item.flyoutData) {
            event.preventDefault();
            event.stopPropagation();
            this.updateFlyoutState(key, true);
            // focus focusable item inside menu
            /* istanbul ignore else */
            if (this._flyoutSourceRefMap[key]) {
                setTimeout(() => {
                    FocusTrap.focusFirstElem(this._flyoutSourceRefMap[key], false);
                });
            }
        }
    }
    /**
     * On left arrow key press or escape, collapse current menu if current menu
     * 	is a flyout menu. Once menu collapsed, find element that triggered
     * 	flyout and do the following:
     * 	  - Set roving tabindex to that element
     *    - Focus that element
     */
    menuItemLeftKeyHandler(parentKey, event) {
        if (parentKey) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            this._keepOverlayOpen = true;
            /* istanbul ignore else */
            if (this._flyoutOverlaysMap[parentKey]) {
                this._flyoutOverlaysMap[parentKey].close();
            }
            this.updateFlyoutState(parentKey, false);
            /* istanbul ignore else */
            if (this._flyoutTargetRefMap[parentKey]) {
                setTimeout(() => {
                    this._flyoutTargetRefMap[parentKey].tabIndex = 0;
                    this._flyoutTargetRefMap[parentKey].focus();
                });
            }
        }
        else if (event.key === KeyboardEventKey.Escape ||
            (this.metadata && this.metadata.isNavMenu)) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            this._keepOverlayOpen = false;
            this.close();
            setTimeout(() => {
                FocusTrap.focusFirstElem(this._targetRef, false);
            });
        }
    }
    /**
     * Listen to the following keyboard events on a given menu item:
     * 	- Enter - select the menu item
     * 	- Right arrow - toggle flyout menu if item has flyout
     * @param {BxfInlineMenuInterface} item
     * @param {string} key
     * @param {KeyboardEvent} event
     */
    menuItemKeyDownHandler(item, key, event) {
        switch (event.key) {
            case KeyboardEventKey.Enter:
            case KeyboardEventKey.SpaceBar:
                this.menuItemEnterHandler(item, key, event);
                break;
            case KeyboardEventKey.ArrowRight:
                this.menuItemRightKeyHandler(item, key, event);
                break;
        }
    }
    flyoutMouseOverHandler(key) {
        const menuItemElement = get(this._flyoutOverlaysMap, `[${key}].targetElement`);
        if (menuItemElement) {
            menuItemElement.classList.add(SELECTED);
        }
    }
    flyoutMouseOutHandler(key) {
        const menuItemElement = get(this._flyoutOverlaysMap, `[${key}].targetElement`);
        if (menuItemElement) {
            menuItemElement.classList.remove(SELECTED);
        }
    }
    addTargetElementHoverStyling() {
        const targetElement = this._targetRef.firstElementChild;
        if (get(targetElement, 'children.length') > 0 &&
            get(this.hoverClass, 'length') > 0) {
            let element;
            if (targetElement) {
                element = targetElement.lastChild;
            }
            else {
                element = targetElement.children[0];
            }
            this.hoverClass.forEach((item) => element.classList.add(item));
        }
        else if (targetElement.lastChild && this.hoverClass) {
            this.hoverClass.forEach((item) => targetElement.lastChild.classList.add(item));
        }
    }
    removeTargetElementHoverStyling() {
        const targetElement = this._targetRef.firstElementChild;
        if (get(targetElement, 'children.length') > 0 &&
            get(this.hoverClass, 'length') > 0) {
            let element;
            if (targetElement) {
                element = targetElement.lastChild;
            }
            else {
                element = targetElement.children[0];
            }
            this.hoverClass.forEach((item) => element.classList.remove(item));
        }
        else if (targetElement.lastChild && this.hoverClass) {
            this.hoverClass.forEach((item) => targetElement.lastChild.classList.remove(item));
        }
    }
    /**
     * Renders left icon for inline menu item
     * @param {BxfInlineMenuInterface} item inline menu item
     */
    renderLeftIcon(item) {
        if (item.leftIcon) {
            return (h("div", { class: MENU_LEFT_ICON, "aria-hidden": 'true' }, h("bxf-icon", { type: item.leftIcon, state: !item.isDisabled &&
                    this.itemHovered === item.label
                    ? 'primary-hover'
                    : item.iconState ||
                        PRIMARY, isDisabled: item.isDisabled, dataTestSuffix: createSelector('00', this.dataTestSuffix, true) })));
        }
        if (item.isSelected) {
            return (h("div", { class: MENU_LEFT_ICON, "aria-hidden": 'true' }, h("bxf-icon", { type: CHECK, state: 'primary', isDisabled: item.isDisabled, dataTestSuffix: createSelector('01', this.dataTestSuffix, true) })));
        }
        // add alert-2 icon if item.hasAlert
        if (item.hasAlert) {
            return (h("div", { class: MENU_LEFT_ICON, "aria-hidden": 'true' }, h("bxf-icon", { type: ALERT_ICON, state: ALERT, isDisabled: item.isDisabled, dataTestSuffix: createSelector('01', this.dataTestSuffix, true) })));
        }
        if (item.hasEmptyIcon) {
            return h("div", { class: MENU_LEFT_ICON, "aria-hidden": 'true' });
        }
        return h("div", { class: MENU_LEFT_ICON_NO, "aria-hidden": 'true' });
    }
    /**
     * Renders right label for inline menu item
     * @param {BxfInlineMenuInterface} item inline menu item
     */
    renderRightLabel(item) {
        return h("div", { class: SECONDARY_LABEL }, item.secondaryLabel);
    }
    /**
     * Renders right link for inline menu item
     * @param {BxfInlineMenuInterface} item inline menu item
     */
    renderRightLink(item) {
        item.rightLink.isFocusable = item.isFocusable;
        return (h("div", { class: ITEM_RIGHT }, h("bxf-link", { ...item.rightLink, dataTestSuffix: createSelector('02', this.dataTestSuffix, true) })));
    }
    /**
     * Renders right button for inline menu item
     * @param {BxfInlineMenuInterface} item inline menu item
     */
    renderRightButton(item) {
        const { type } = item.rightButton;
        const buttonProps = {
            ...item.rightButton,
        };
        buttonProps.size = BxfButtonSizeEnum.XSMALL;
        if (type) {
            buttonProps.type = !BUTTON_TYPES.includes(type)
                ? BxfButtonTypeEnum.TERTIARY
                : buttonProps.type;
        }
        else {
            buttonProps.type = BxfButtonTypeEnum.TERTIARY;
        }
        buttonProps.isFocusable = item.isFocusable;
        return (h("div", { class: ITEM_RIGHT }, h("bxf-button", { ...buttonProps, dataTestSuffix: createSelector('02', this.dataTestSuffix, true) })));
    }
    /**
     * Renders right badge for inline menu item
     * @param {BxfInlineMenuInterface} item inline menu item
     */
    renderRightBadge(item) {
        const { size } = item.rightBadge;
        const badgeProps = {
            ...item.rightBadge,
        };
        if (size) {
            badgeProps.size =
                size === BxfBadgeSizeEnum.LARGE
                    ? BxfBadgeSizeEnum.SMALL
                    : badgeProps.size;
        }
        return (h("div", { class: MENU_RIGHT_ICON }, h("bxf-badge", { ...badgeProps, dataTestSuffix: createSelector('02', this.dataTestSuffix, true) })));
    }
    /**
     * Renders right icon for inline menu item
     * @param {BxfInlineMenuInterface} item inline menu item
     */
    renderRightIcon(item) {
        return (h("div", { class: MENU_RIGHT_ICON, "aria-hidden": 'true' }, h("bxf-icon", { type: ARROW_RIGHT, state: 'primary', isDisabled: item.isDisabled, dataTestSuffix: createSelector('02', this.dataTestSuffix, true) })));
    }
    /**
     * Renders right element for inline menu item
     * @param {BxfInlineMenuInterface} item inline menu item
     */
    renderRightElement(item) {
        if (item.flyoutData) {
            return this.renderRightIcon(item);
        }
        if (item.rightBadge) {
            return this.renderRightBadge(item);
        }
        if (item.rightButton) {
            return this.renderRightButton(item);
        }
        if (item.rightLink) {
            return this.renderRightLink(item);
        }
        if (item.secondaryLabel) {
            return this.renderRightLabel(item);
        }
        return h("div", { class: MENU_RIGHT_ICON_NO, "aria-hidden": 'true' });
    }
    /**
     * Generate unique ID for flyout menu
     */
    getFlyoutId(key) {
        return `flyout_${this._uid}${key}`;
    }
    renderFlyout(data, index) {
        const flyoutData = get(data, FLYOUT_DATA);
        if (!isEmpty(flyoutData)) {
            return (h("ul", { ref: (el) => this.flyoutSourceRefHandler(el, index), id: this.getFlyoutId(index), class: FLYOUT, onMouseOver: () => this.flyoutMouseOverHandler(index), onMouseOut: () => this.flyoutMouseOutHandler(index), onKeyDown: (ev) => this.menuKeyDownHandler(ev, this._flyoutSourceRefMap[index], index), role: Role.MENU, "aria-label": data.label }, this.renderMenu(flyoutData, index)));
        }
        return null;
    }
    /**
     * Given a parent/item key and item data, render the menu item
     */
    renderMenuItem(item, itemKey, parentKey) {
        const isCompact = this.isCompact ? MENU_ITEM_COMPACT : '';
        const hasAlert = item.hasAlert ? ALERT : '';
        const css = `${MENU_ITEM} ${isCompact} ${item.isDisabled ? DISABLED : hasAlert}`;
        const key = `${parentKey}_${itemKey}`;
        const dataLinkEvent = item.dataLinkEvent
            ? // eslint-disable-next-line @typescript-eslint/naming-convention
                { 'data-link-event': item.dataLinkEvent }
            : {};
        return (h("li", { class: MENU_ITEM_WRAPPER, role: Role.NONE, onMouseEnter: () => {
                this.itemHovered = item.label;
            }, onMouseLeave: () => {
                this.itemHovered = '';
            }, onFocus: () => {
                this.itemHovered = item.label;
            }, onBlur: () => {
                this.itemHovered = '';
            } }, h("div", { ref: (el) => item.flyoutData
                ? this.flyoutTargetRefHandler(el, key)
                : null, class: getKeyboardFocusCSS(css, this.keepMouseFocus), onClick: (event) => this.menuItemClickHandler(item, key, event), onKeyDown: (event) => this.menuItemKeyDownHandler(item, key, event), role: Role.MENUITEM, "aria-disabled": item.isDisabled ? 'true' : null, "aria-haspopup": item.flyoutData ? 'true' : null, "aria-expanded": item.flyoutData ? 'false' : null, tabindex: item.isFocusable ? 0 : -1, "data-bxf-key": key, ...dataLinkEvent }, this.renderLeftIcon(item), item.label, this.renderRightElement(item)), this.renderFlyout(item, key)));
    }
    /**
     * Renders the inline menu group
     * @param {Array<BxfInlineMenuInterface>} menuGroup items to be rendered in the menu group
     * @param parentKey {string} represents the parent key
     */
    renderMenuGroup(menuGroup, parentKey) {
        return map(menuGroup, (item, itemKey) => this.renderMenuItem(item, itemKey, parentKey));
    }
    /**
     * Starting point for rendering inline menu and flyout menu
     * @param {Array<Array<BxfInlineMenuInterface>>} menu items to be rendered in the menu
     * @param parentKey {string} represents the parent key
     */
    renderMenu(menu, parentKey) {
        return map(menu, (menuGroup, itemKey) => {
            /* istanbul ignore else */
            if (!isEmpty(menuGroup)) {
                const isLastItemOfMenu = itemKey === menu.length - 1;
                const borderBottomElement = isLastItemOfMenu ? null : (h("div", { class: GROUP_SEPARATOR, role: Role.SEPARATOR }));
                const key = `${parentKey}_${itemKey}`;
                return [
                    h("div", { key: key, class: getKeyboardFocusCSS(`${MENU_GROUP}`, this.keepMouseFocus), "data-bxf-parent": parentKey || null }, this.renderMenuGroup(menuGroup, key)),
                    borderBottomElement,
                ];
            }
            return undefined;
        }).filter(Boolean);
    }
    render() {
        return (h("div", { key: 'a92d2523bcb9b725e9afa0f08e7bbd3b354731c1', "data-test": createSelector(this.host.tagName, this.dataTestSuffix) }, h("div", { key: '3ba201c71a823a652008fca2f7f538c99786ae72', role: Role.PRESENTATION, class: CONTAINER, ref: (el) => {
                this._targetRef = el;
            }, onClick: () => this.updateState(!this.isOpen) }, h("slot", { key: '009374d78c9a7712b4292a83857309c3453c1ae5', name: TARGET })), h("ul", { key: '3eb4e43ba23b35c255e2ee5421415a0f7b81e9e4', onMouseOver: () => {
                if (this.trigger === BxfOverlayTriggerEnum.HOVER) {
                    this._keepOverlayOpen = true;
                }
                this.addTargetElementHoverStyling();
            }, onMouseOut: () => {
                if (this.trigger === BxfOverlayTriggerEnum.HOVER) {
                    this._keepOverlayOpen = false;
                }
                this.removeTargetElementHoverStyling();
            }, onKeyDown: (ev) => this.menuKeyDownHandler(ev, this._sourceRef, ''), class: this.isOpen ? SHOW : HIDE, ref: (el) => {
                this._sourceRef = el;
            }, role: Role.MENU, "aria-label": this.assistiveLabel }, h("bxf-icon", { key: 'f7e62aa097e6893722479dfe1e5d17c6f569f174', class: CLOSE_BUTTON, type: BxfIconTypeEnum['bxf-close'], onClick: () => this.closeOverlay() }), this.renderMenu(this.data, ''))));
    }
    static get watchers() { return {
        "isOpen": ["isOpenHandler"]
    }; }
    static get style() { return BxfInlineMenuStyle0; }
}, [6, "bxf-inline-menu", {
        "data": [16],
        "trigger": [513],
        "hoverClass": [16],
        "metadata": [16],
        "eventData": [16],
        "overridePlacement": [1, "override-placement"],
        "sourceElementCustomClass": [16],
        "targetElementCustomClass": [16],
        "scrollToFit": [516, "scroll-to-fit"],
        "isTracking": [4, "is-tracking"],
        "trackingData": [16],
        "isCompact": [4, "is-compact"],
        "assistiveLabel": [1, "assistive-label"],
        "parentOverlayContainerSelector": [513, "parent-overlay-container-selector"],
        "dataTestSuffix": [8, "data-test-suffix"],
        "isOpen": [1540, "is-open"],
        "keepMouseFocus": [4, "keep-mouse-focus"],
        "namespaceI18n": [1, "namespace-i-1-8n"],
        "i18nKeys": [16],
        "useFocusVisible": [4, "use-focus-visible"],
        "isFlyoutOpenMap": [32],
        "itemHovered": [32],
        "open": [64],
        "close": [64]
    }, [[8, "tabBarItemSelected", "handleTabSwitch"]], {
        "isOpen": ["isOpenHandler"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bxf-inline-menu", "bxf-badge", "bxf-button", "bxf-icon", "bxf-link"];
    components.forEach(tagName => { switch (tagName) {
        case "bxf-inline-menu":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BxfInlineMenu);
            }
            break;
        case "bxf-badge":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "bxf-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "bxf-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "bxf-link":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { BxfInlineMenu as B, defineCustomElement as d };
